import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { DeviceDetectorService } from 'ngx-device-detector';
import {
  SocialLoginModule,
  SocialAuthServiceConfig,
} from 'angularx-social-login';
import { GoogleLoginProvider } from 'angularx-social-login';
import { HttpClientModule } from '@angular/common/http';
import { MatDialogModule } from '@angular/material/dialog';
import { MatStepperModule } from '@angular/material/stepper';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MainMenuToggleService } from './services/utility.service'
import { SharedService } from './services/shared.service';
import { FileSaverModule } from 'ngx-filesaver';
import { NgxImageCompressService } from 'ngx-image-compress';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SeoService } from './seo.service';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { FullLayoutComponent } from './shared/components/fulllayout.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { LoginComponent } from './shared/components/Login/Login.component';
import { VideoCategoryComponent } from './features-modules/category/videocategory/videocategory.component';
import { CardCategoryComponent } from './features-modules/category/card-category/card-category.component';
import { VideoCardSharedModule } from './features-modules/video-card-shared/video-card-shared.module';
import { MasterCategoryComponent } from './features-modules/category/master-category/master-category.component';
import { FilterVideoSubCategoryPipe } from './pipe/filter-video-sub-category-description.pipe';
import { JwtModule } from '@auth0/angular-jwt';
import { CategoryFiltersComponent } from './features-modules/category/category-filters/category-filters.component';
import { VideoViewPopupComponent } from './features-modules/category/video-view-popup/video-view-popup.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';


let socialloginproviders = {
  "google": {
    "clientId": "198139196569-htmb3e5vgdeegm6uancn6mfvi3b9ip2a.apps.googleusercontent.com"
  },
  "facebook": {
    "clientId": "188490602973182",
    "apiVersion": "v6.0"
  }
};

const routes: Routes = [
  {
    path: '',
    component: FullLayoutComponent,
    children: [
      {
        path: '', loadChildren: () =>
          import(
            '../app/features-modules/home-page/home-page.module'
          ).then((m) => m.HomePageModule)
      },
      {
        path: 'admin',
        loadChildren: () =>
          import(
            '../app/admin/admin.module'
          ).then((m) => m.AdminModule),
      },
      {
        path: 'preview', loadChildren: () =>
          import(
            '../app/features-modules/preview/preview.module'
          ).then((m) => m.PreviewModule)
      },
      {
        path: 'personalise', loadChildren: () =>
          import(
            '../app/features-modules/personalise/personalise.module'
          ).then((m) => m.PersonaliseModule)
      },
      {
        path: 'userpayment', loadChildren: () =>
          import(
            '../app/features-modules/payment/payment.module'
          ).then((m) => m.PaymentModule)
      },
      {
        path: 'user',
        loadChildren: () => import('../app/features-modules/user/user.module').then((m) => m.UserModule)
      },
      { path: ':categorySlug', component: VideoCategoryComponent },
      { path: ':category/videos-invitation-maker/:data', component: VideoCategoryComponent },
      { path: ':category/:subCategory/videos-invitation-maker/:data', component: VideoCategoryComponent },
      { path: ':category/cards-invitation-maker/:data', component: CardCategoryComponent },
      { path: ':category/:subCategory/cards-invitation-maker/:data', component: CardCategoryComponent },
      { path: ':category', component: MasterCategoryComponent },
      { path: '**', redirectTo: '/', pathMatch: 'full' },
      
    ]
  }
]

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    VideoCategoryComponent,
    CardCategoryComponent,
    MasterCategoryComponent,
    CategoryFiltersComponent,
    FilterVideoSubCategoryPipe,
    VideoViewPopupComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' }),
    ToastrModule.forRoot(),
    HttpClientModule,
    MatDialogModule,
    MatStepperModule,
    CarouselModule,
    FileSaverModule,
    MatProgressBarModule,
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      useHash: false
    }),
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    SocialLoginModule,
    BrowserAnimationsModule,
    SharedModule,
    VideoCardSharedModule,
    NgxIntlTelInputModule
  ],
  entryComponents: [
    LoginComponent
  ],
  providers: [MainMenuToggleService, NgbActiveModal, SharedService, DeviceDetectorService, NgxImageCompressService, SeoService,
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider('198139196569-htmb3e5vgdeegm6uancn6mfvi3b9ip2a.apps.googleusercontent.com'),
          },
        ],
      } as SocialAuthServiceConfig,
    },],
  bootstrap: [AppComponent]

})
export class AppModule {

}
